import React, { useState } from 'react';
import api from './api';

// We add "onRegisterSuccess" as a prop here
const Register = ({ onRegisterSuccess }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState(''); 

    const handleRegister = async (e) => {
        e.preventDefault(); 

        try {
            const response = await api.post('/api/auth/register', {
                username,
                email,
                password 
            });
            
            alert("Registration successful! You can now login.");
            console.log(response.data);

            // TRIGGER THE SWITCH: This tells App.js to go back to the Login screen
            if (onRegisterSuccess) {
                onRegisterSuccess();
            }
            
        } catch (err) {
            console.error(err);
            alert("Registration failed: " + (err.response?.data?.error || "Server error"));
        }
    };

    return (
        <div className="auth-card">
            <h2>Create Account</h2>
            <form onSubmit={handleRegister}>
                <input 
                    type="text" placeholder="Username"
                    onChange={(e) => setUsername(e.target.value)} 
                    required
                /><br/>
                <input 
                    type="email" placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}   
                    required 
                /><br/>
                <input 
                    type="password" placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)} 
                    required
                /><br/>
                <button type="submit">Register</button>
            </form>
        </div>
    );
};

export default Register;